import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { usePromotion } from "../../hooks/usePromotion";
import styles from "./PromotionBanner.module.css";

const FORTY_EIGHT_HOURS_MS = 48 * 60 * 60 * 1000;

function formatRemaining(ms: number): string {
  if (ms <= 0) return "0h 00m 00s";
  const totalSeconds = Math.floor(ms / 1000);
  const seconds = totalSeconds % 60;
  const totalMinutes = Math.floor(totalSeconds / 60);
  const minutes = totalMinutes % 60;
  const totalHours = Math.floor(totalMinutes / 60);
  const pad = (n: number) => String(n).padStart(2, "0");

  if (ms > FORTY_EIGHT_HOURS_MS) {
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;
    return `${days}d ${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;
  }
  return `${totalHours}h ${pad(minutes)}m ${pad(seconds)}s`;
}

export function PromotionBanner() {
  const { promotion, isActive } = usePromotion();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!isActive) return;
    const interval = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, [isActive]);

  if (!isActive || !promotion || !promotion.endsAt) return null;

  const endsAtMs = new Date(promotion.endsAt).getTime();
  const remainingMs = endsAtMs - now;
  if (remainingMs <= 0) return null;

  return (
    <div className={styles.banner}>
      <Sparkles size={28} className={styles.icon} />
      <span className={styles.text}>
        {promotion.label || `${promotion.discountPercent}% off for a limited time!`}
      </span>
      {promotion.showDuration && (
        <span className={styles.countdown}>
          Ends in {formatRemaining(remainingMs)}
        </span>
      )}
    </div>
  );
}